import { Box, Dialog, DialogActions } from "@mui/material";
import React from "react";
import { ICONS } from "../../shared/constants/enums";
import CloseBtn from "./CloseBtn";
import Heading from "./Heading";
import Button from "./Button";

type ConfirmDialogProps = {
  icon?: ICONS;
  text: string | React.ReactNode | any;
  width?: "sm" | "md" | "lg" | "xs";
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  handleConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
  className?: string | any;
  iconColor?: any;
};

const ConfirmDialog = ({
  icon,
  text,
  width = "md",
  dialogOpen,
  setDialogOpen,
  handleConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmDisabled = false,
  className,
  iconColor = "var(--color-warning-main)",
}: ConfirmDialogProps) => {
  return (
    <Dialog
      open={dialogOpen}
      maxWidth={width}
      fullWidth
      onClose={() => setDialogOpen(false)}
    >
      <Box
        sx={{
          padding: "15px 10px 0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <CloseBtn onClose={() => setDialogOpen(false)} />

        <div
          style={{ textAlign: "center", marginTop: "20px", color: iconColor }}
        >
          <span
            className={`material-symbols-outlined ${className ?? ""}`}
            style={{ fontSize: "60px" }}
          >
            {icon}
          </span>
        </div>

        <Heading
          text={text}
          type="h5"
          isBold
          font="1.25rem"
          style={{ marginTop: "20px" }}
        />

        <DialogActions
          sx={{
            m: "20px 0px 22px 0px",
            display: "flex",
            justifyContent: "center",
            columnGap: "10px",
            alignItems: "center",
          }}
        >
          <Button
            text="Cancel"
            fullWidth={false}
            variant="outlined"
            type="button"
            onClick={() => setDialogOpen(false)}
          />
          <Button
            disabled={confirmDisabled}
            text={confirmText}
            fullWidth={false}
            className="ml-1"
            onClick={handleConfirm}
          />
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ConfirmDialog;
